export enum ETacticControlState {
  UNTOUCHED = 'untouched',
  CREATE = 'create',
  REMOVE = 'remove',
  EDIT = 'edit',
}
